export const PRONOSTICS_QUERY_KEYS = {
  all: ["pronostics"] as const,
  catalog: () => [...PRONOSTICS_QUERY_KEYS.all, "catalog"] as const,
  ranking: (competitionId: string) =>
    [...PRONOSTICS_QUERY_KEYS.all, "ranking", competitionId] as const,
  organizationSettings: (competitionId: string) =>
    [...PRONOSTICS_QUERY_KEYS.all, "organization-settings", competitionId] as const,
  prizes: (competitionId: string) =>
    [...PRONOSTICS_QUERY_KEYS.all, "prizes", competitionId] as const,
} as const;
